module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.upload.status == 'ready') ? _c('form', {
    on: {
      "submit": _vm.insertImage
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    attrs: {
      "type": "text",
      "maxlength": "255",
      "placeholder": _vm.$parent.locale['please enter a url']
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale.save))]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.pick
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale.upload))]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none !important"
    },
    attrs: {
      "type": "file",
      "accept": "image/png,image/jpeg,image/gif,image/jpg"
    },
    on: {
      "change": _vm.selectFile
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.upload.status == 'progress') ? _c('div', [_vm._v("\n        " + _vm._s(_vm.$parent.locale.progress) + ":" + _vm._s(_vm.progressComputable ? _vm.$parent.locale.unknown : _vm.upload.complete) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.upload.status == 'success') ? _c('div', [_vm._v("\n        " + _vm._s(_vm.$parent.locale["please wait"]) + "...\n    ")]) : _vm._e(), _vm._v(" "), (_vm.upload.status == 'error') ? _c('div', [_vm._v("\n        " + _vm._s(_vm.$parent.locale.upload) + " " + _vm._s(_vm.$parent.locale.error) + ",\n        "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale.reset))])]) : _vm._e(), _vm._v(" "), (_vm.upload.status == 'abort') ? _c('div', [_vm._v("\n        " + _vm._s(_vm.$parent.locale.upload) + " " + _vm._s(_vm.$parent.locale.abort) + ",\n        "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$parent.locale.reset))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-fdcb1970!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/src/modules/image/dashboard.vue
// module id = 688
// module chunks = 0